import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Chip from 'components/common/Chip';
import Tooltip from 'components/common/Tooltip';

import MultiSegmentProgressBar from 'components/common/MultiSegmentProgressBar';

import claimAdjustmentReasonCodes from 'config/claimAdjustmentReasonCodes';

const styles = theme => ({
  root: {
    padding: '8px 16px 8px 0',
  },
  chip: {
    marginRight: 8,
  },
  denialReasonCount: {
    marginLeft: 8,
  },
});

const EraChartDenialReasons = ({
  denialReasons,
  classes,
  theme,
}) => {
  const maxDenialReasonCount = Object.keys(denialReasons).reduce((accumulator, currentValue) => {
    return Math.max(accumulator, denialReasons[currentValue]);
  }, 0);
  return (
    <div className={classes.root}>
      <Typography>
        Top Denial Reasons
      </Typography>
      <List>
        {Object.keys(denialReasons).map(key => (
          <ListItem
            key={key}
            dense
            disableGutters
          >
            <Tooltip
              content={(
                <Typography>
                  {claimAdjustmentReasonCodes[key] || key}
                </Typography>
              )}
              placement="top"
              color="white"
            >
              <Chip
                className={classes.chip}
                label={key}
                size="sm"
                square
              />
            </Tooltip>
            <MultiSegmentProgressBar
              segments={[
                {
                  value: denialReasons[key],
                  color: theme.palette.states.rejected,
                },
                {
                  value: maxDenialReasonCount - denialReasons[key],
                },
              ]}
              height={4}
              gap={1}
              borderRadius={4}
              showLabels
            />
            <Typography className={classes.denialReasonCount} variant="caption">
              {denialReasons[key]}
            </Typography>
          </ListItem>
        ))}
      </List>
    </div>
  );
};

EraChartDenialReasons.propTypes = {
  eraData: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        500: PropTypes.string.isRequired,
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        600: PropTypes.string.isRequired,
      }).isRequired,
      common: PropTypes.shape({
        white: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles, { withTheme: true })(EraChartDenialReasons);



// WEBPACK FOOTER //
// ./src/components/home/EraChart/EraChartDenialReasons.js